import React, { useEffect } from "react";
import { useAppContext } from "../../contexts";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";

/* 
    use the below value only for type prop
    1. error
    2. warning
    3. info
    4. success
*/
export const Toast = ({ toastMessage, type }) => {
  const storeConfigState = useSelector((state) => state.storeSettings);
  const { setIsInternalServerError } = useAppContext();
  const navigate = useNavigate();
  useEffect(() => {
    switch (type) {
      case "error":
        toastMessage =
          toastMessage || storeConfigState?.themeConfig?.internal_server_error;
        break;
      case "warning":
        toastMessage = toastMessage || "";
        break;
      case "info":
        toastMessage = toastMessage || "";
        break;
      case "success":
        toastMessage = toastMessage || "";
        break;
      default:
    }
    notify();
    let timer;
    if (type === "error") {
      timer = setTimeout(() => {
        setIsInternalServerError(false);
        // navigate("/");
      }, 3000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const notify = () => toast(toastMessage);
  return (
    <>
      <ToastContainer autoClose={3000} pauseOnFocusLoss />;
    </>
  );
};
